// import React, { useEffect, useState } from "react";
// import { Heart, Loader2, Star } from "lucide-react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../../utils/CartContext";
// import { useCurrency } from "../../../context/CurrencyContext";
// import { formatingPrice } from "../../../utils/formatingPrice";
// import { useTranslation } from "react-i18next";

// const DesireChooseSection = () => {
//   const { currency, convertPrice } = useCurrency();
//   const navigate = useNavigate();
//   const { fetchCartCount } = useCart();
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language || "en";

//   const [products, setProducts] = useState([]);
//   const [wishlist, setWishlist] = useState([]);
//   const [loadingHearts, setLoadingHearts] = useState(new Set());
//   const [loadingCart, setLoadingCart] = useState(new Set());
//   const [loading, setLoading] = useState(true);
//   const storedUser = localStorage.getItem("pm-user-data");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   const userId = user?._id;

//   useEffect(() => {
//     AOS.init({ duration: 800, once: true, offset: 100 });
//     fetchProducts();
//     if (userId) fetchWishlist();
//   }, [userId]);

//   // Helper function to get localized text
//   const getLocalizedText = (item, field) => {
//     if (!item || !item[field]) return "";
    
//     // If value is a string (backward compatibility)
//     if (typeof item[field] === 'string') {
//       return item[field];
//     }
    
//     // If value is an object with language keys
//     if (typeof item[field] === 'object') {
//       // Return the value in current language, fallback to English, then first available
//       return item[field][currentLanguage] || 
//              item[field].en || 
//              item[field].hi || 
//              item[field].es || 
//              item[field].zh || 
//              "";
//     }
    
//     return "";
//   };

//   const fetchProducts = async () => {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/products/get-all-products`
//       );
//       const allProducts = res.data?.products || [];
//       setProducts(allProducts.slice(0, 14));
//     } catch (error) {
//       console.error("Error fetching products:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Re-fetch product names when language changes
//   useEffect(() => {
//     if (products.length > 0) {
//       // Update products with current language
//       const updatedProducts = products.map(product => ({
//         ...product,
//         localizedName: getLocalizedText(product, "name"),
//         localizedDescription: getLocalizedText(product, "description")
//       }));
//       setProducts(updatedProducts);
//     }
//   }, [currentLanguage, products.length]);

//   // ❤️ Fetch wishlist
//   const fetchWishlist = async () => {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${userId}`
//       );
//       const ids = res?.data?.products?.map((p) => p._id?.toString()) || [];
//       setWishlist(ids);
//     } catch (error) {
//       console.error("Error fetching wishlist:", error);
//     }
//   };

//   // ❤️ Toggle wishlist
//   const toggleWishlist = async (productId) => {
//     if (!userId) {
//       toast.error(t("login_for_wishlist") || "Please login to use wishlist ❤️");
//       return;
//     }

//     const isLiked = wishlist.includes(productId.toString());
//     setLoadingHearts((prev) => new Set(prev).add(productId));

//     try {
//       const endpoint = isLiked
//         ? `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`
//         : `${process.env.REACT_APP_API_URL}/wishlist/add-to-wishlist`;

//       await axios.post(endpoint, { userId, productId });
//       await fetchWishlist();
//     } catch (error) {
//       toast.error(t("something_went_wrong") || "Something went wrong!");
//     } finally {
//       setLoadingHearts((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(productId);
//         return newSet;
//       });
//     }
//   };

//   // 🛒 Add to Cart
//   const handleAddToCart = async (productId) => {
//     if (!userId) {
//       toast.error(t("login_for_cart") || "Please login to add items to cart 🛒");
//       return;
//     }

//     setLoadingCart((prev) => new Set(prev).add(productId));
//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}/cart/add-product-to-cart`,
//         {
//           userId,
//           productId,
//           quantity: 1,
//         }
//       );
//       toast.success(t("added_to_cart") || "Added to cart!");
//       fetchCartCount();
//     } catch (error) {
//       toast.error(t("add_to_cart_failed") || "Failed to add to cart");
//     } finally {
//       setLoadingCart((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(productId);
//         return newSet;
//       });
//     }
//   };

//   // ⭐ Render Rating
//   const renderStars = (rating) => (
//     <div className="flex justify-center gap-1 mb-2">
//       {[...Array(5)].map((_, index) => (
//         <Star
//           key={index}
//           className={`w-4 h-4 ${
//             index < Math.round(rating)
//               ? "text-yellow-400 fill-yellow-400"
//               : "text-gray-300"
//           }`}
//         />
//       ))}
//       {rating && (
//         <span className="text-xs text-gray-500 ml-1">{rating.toFixed(1)}</span>
//       )}
//     </div>
//   );

//   const handleProductClick = (id) => navigate(`/product-details/${id}`);

//   // Get product name with fallback
//   const getProductName = (product) => {
//     if (product.localizedName) {
//       return product.localizedName;
//     }
//     return getLocalizedText(product, "name") || product?.name || t("unnamed_product");
//   };

//   if (loading)
//     return (
//       <div className="flex justify-center items-center py-20">
//         <Loader2 className="w-8 h-8 animate-spin text-orange-500" />
//       </div>
//     );

//   return (
//     <div className="bg-gradient-to-b from-orange-50 to-white pb-10 px-4 md:px-10">
//       <div className="w-full mx-auto py-4">
//         {/* Header */}
//         <div
//           className="flex flex-col sm:flex-row justify-between items-center mb-8"
//           data-aos="fade-down"
//         >
//           <h2 className="text-2xl sm:text-3xl md:text-4xl font-philosopher text-[#002815]">
//             {t("as_you_desire") || "As You Desire, As You Choose"}
//           </h2>
//           <button
//             className="text-red-500 hover:text-red-600 font-medium text-sm md:text-base transition-colors"
//             onClick={() => navigate("/allproduct")}
//           >
//             {t("view_all") || "View All"}
//           </button>
//         </div>

//         {/* Product Grid */}
//         <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7 gap-2">
//           {products.map((product, index) => {
//             const productId = product._id?.toString();
//             const isLiked = wishlist.includes(productId);
//             const isHeartLoading = loadingHearts.has(productId);
//             const isCartLoading = loadingCart.has(productId);
//             const productName = getProductName(product);

//             return (
//               <div
//                 key={productId}
//                 onClick={() => handleProductClick(productId)}
//                 className="group bg-[#f7f3f3] rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all cursor-pointer duration-300 relative"
//                 data-aos="fade-up"
//                 data-aos-delay={index * 100}
//               >
//                 {/* Wishlist Button */}
//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     toggleWishlist(productId);
//                   }}
//                   disabled={isHeartLoading}
//                   className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/90 shadow-md hover:bg-gray-100 transition-all duration-300"
//                 >
//                   {isHeartLoading ? (
//                     <Loader2 className="w-4 h-4 text-red-500 animate-spin" />
//                   ) : (
//                     <Heart
//                       className={`w-5 h-5 ${
//                         isLiked
//                           ? "fill-red-500 stroke-red-500"
//                           : "stroke-gray-800 hover:scale-110"
//                       } transition-all`}
//                     />
//                   )}
//                 </button>

//                 {/* Product Image */}
//                 <div className="relative bg-[#E5E5E5] overflow-hidden aspect-square">
//                   <img
//                     src={
//                       product.images?.[0] ||
//                       "https://via.placeholder.com/300x300?text=No+Image"
//                     }
//                     alt={productName}
//                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                     onError={(e) => {
//                       e.target.src = "https://via.placeholder.com/300x300?text=No+Image";
//                     }}
//                   />
//                 </div>

//                 {/* Product Info */}
//                 <div className="p-2">
//                   {renderStars(product.ratings || 0)}

//                   <h3 className="text-xs sm:text-sm text-gray-700 text-center mb-2 line-clamp-2 ">
//                     {productName}
//                   </h3>

//                   <div className="text-center">
//                     <div className="flex items-center justify-center gap-2">
//                       {product.previous_price && (
//                         <div className="text-xs sm:text-sm text-red-400 line-through">
//                           {formatingPrice(
//                             convertPrice(product.previous_price),
//                             currency
//                           )}
//                         </div>
//                       )}

//                       <div className="text-base sm:text-lg font-bold text-gray-900">
//                         {formatingPrice(convertPrice(product.price), currency)}
//                       </div>
//                     </div>
//                   </div>

//                   {/* Add to Cart */}
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleAddToCart(productId);
//                     }}
//                     disabled={isCartLoading}
//                     className="mt-3 w-full bg-white border-2 border-gray-900 text-gray-900 py-1 md:py-2 text-sm font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
//                   >
//                     {isCartLoading ? (
//                       <div className="flex justify-center items-center gap-2">
//                         <Loader2 className="w-4 h-4 animate-spin" />
//                         {t("adding") || "ADDING"}...
//                       </div>
//                     ) : (
//                       t("add_to_cart") || "ADD TO CART"
//                     )}
//                   </button>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DesireChooseSection;




import React, { useEffect, useState } from "react";
import { Heart, Loader2, Star } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../../utils/CartContext";
import { useCurrency } from "../../../context/CurrencyContext";
import { formatingPrice } from "../../../utils/formatingPrice";
import { useTranslation } from "react-i18next";
import GuestSession from "../../../utils/guestSession";

const DesireChooseSection = () => {
  const { currency, convertPrice } = useCurrency();
  const navigate = useNavigate();
  const { fetchCartCount } = useCart();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const [products, setProducts] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [loadingHearts, setLoadingHearts] = useState(new Set());
  const [loadingCart, setLoadingCart] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const storedUser = localStorage.getItem("pm-user-data");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userId = user?._id;
  const isLoggedIn = !!userId;

  useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 100 });
    fetchProducts();
    fetchWishlist();
  }, []);

  // Helper function to get localized text
  const getLocalizedText = (item, field) => {
    if (!item || !item[field]) return "";
    
    if (typeof item[field] === 'string') {
      return item[field];
    }
    
    if (typeof item[field] === 'object') {
      return item[field][currentLanguage] || 
             item[field].en || 
             item[field].hi || 
             item[field].es || 
             item[field].zh || 
             "";
    }
    
    return "";
  };

  const fetchProducts = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/get-all-products`
      );
      const allProducts = res.data?.products || [];
      setProducts(allProducts.slice(0, 14));
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  // Re-fetch product names when language changes
  useEffect(() => {
    if (products.length > 0) {
      const updatedProducts = products.map(product => ({
        ...product,
        localizedName: getLocalizedText(product, "name"),
        localizedDescription: getLocalizedText(product, "description")
      }));
      setProducts(updatedProducts);
    }
  }, [currentLanguage, products.length]);

  // ❤️ Fetch wishlist - works for both logged in and guest
  const fetchWishlist = async () => {
    try {
      if (isLoggedIn) {
        // Logged in user - fetch from API
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${userId}`
        );
        const ids = res?.data?.products?.map((p) => p._id?.toString()) || [];
        setWishlist(ids);
      } else {
        // Guest user - get from localStorage
        const guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
        setWishlist(guestWishlist);
      }
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
  };

  // ❤️ Toggle wishlist - works for both logged in and guest
  const toggleWishlist = async (productId) => {
    const isLiked = wishlist.includes(productId.toString());
    setLoadingHearts((prev) => new Set(prev).add(productId));

    try {
      if (isLoggedIn) {
        // Logged in user
        const endpoint = isLiked
          ? `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`
          : `${process.env.REACT_APP_API_URL}/wishlist/add-to-wishlist`;
        await axios.post(endpoint, { userId, productId });
        await fetchWishlist();
        toast.success(isLiked ? "Removed from wishlist" : "Added to wishlist");
      } else {
        // Guest user - use localStorage
        let guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
        if (isLiked) {
          guestWishlist = guestWishlist.filter(id => id !== productId);
        } else {
          guestWishlist.push(productId);
        }
        localStorage.setItem('guestWishlist', JSON.stringify(guestWishlist));
        setWishlist(guestWishlist);
        window.dispatchEvent(new Event('guest-wishlist-updated'));
        toast.success(isLiked ? "Removed from wishlist" : "Added to wishlist");
      }
    } catch (error) {
      toast.error(t("something_went_wrong") || "Something went wrong!");
    } finally {
      setLoadingHearts((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  // 🛒 Add to Cart - works for both logged in and guest
  const handleAddToCart = async (productId) => {
    setLoadingCart((prev) => new Set(prev).add(productId));

    try {
      if (isLoggedIn) {
        // Logged in user
        await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          {
            userId,
            productId,
            quantity: 1,
          }
        );
      } else {
        // Guest user
        const guestId = GuestSession.getGuestId();
        await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          {
            guestId,
            productId,
            quantity: 1,
          }
        );
      }
      toast.success(t("added_to_cart") || "Added to cart!");
      await fetchCartCount();
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error(error.response?.data?.message || t("add_to_cart_failed") || "Failed to add to cart");
    } finally {
      setLoadingCart((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  // ⭐ Render Rating
  const renderStars = (rating) => (
    <div className="flex justify-center gap-1 mb-2">
      {[...Array(5)].map((_, index) => (
        <Star
          key={index}
          className={`w-4 h-4 ${
            index < Math.round(rating)
              ? "text-yellow-400 fill-yellow-400"
              : "text-gray-300"
          }`}
        />
      ))}
      {rating && (
        <span className="text-xs text-gray-500 ml-1">{rating.toFixed(1)}</span>
      )}
    </div>
  );

  const handleProductClick = (id) => navigate(`/product-details/${id}`);

  // Get product name with fallback
  const getProductName = (product) => {
    if (product.localizedName) {
      return product.localizedName;
    }
    return getLocalizedText(product, "name") || product?.name || t("unnamed_product");
  };

  if (loading)
    return (
      <div className="flex justify-center items-center py-20">
        <Loader2 className="w-8 h-8 animate-spin text-orange-500" />
      </div>
    );

  return (
    <div className="bg-gradient-to-b from-orange-50 to-white pb-10 px-4 md:px-10">
      <div className="w-full mx-auto py-4">
        {/* Header */}
        <div
          className="flex flex-col sm:flex-row justify-between items-center mb-8"
          data-aos="fade-down"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-philosopher text-[#002815]">
            {t("as_you_desire") || "As You Desire, As You Choose"}
          </h2>
          <button
            className="text-red-500 hover:text-red-600 font-medium text-sm md:text-base transition-colors"
            onClick={() => navigate("/allproduct")}
          >
            {t("view_all") || "View All"}
          </button>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7 gap-2">
          {products.map((product, index) => {
            const productId = product._id?.toString();
            const isLiked = wishlist.includes(productId);
            const isHeartLoading = loadingHearts.has(productId);
            const isCartLoading = loadingCart.has(productId);
            const productName = getProductName(product);

            return (
              <div
                key={productId}
                onClick={() => handleProductClick(productId)}
                className="group bg-[#f7f3f3] rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all cursor-pointer duration-300 relative"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                {/* Wishlist Button */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleWishlist(productId);
                  }}
                  disabled={isHeartLoading}
                  className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/90 shadow-md hover:bg-gray-100 transition-all duration-300"
                >
                  {isHeartLoading ? (
                    <Loader2 className="w-4 h-4 text-red-500 animate-spin" />
                  ) : (
                    <Heart
                      className={`w-5 h-5 ${
                        isLiked
                          ? "fill-red-500 stroke-red-500"
                          : "stroke-gray-800 hover:scale-110"
                      } transition-all`}
                    />
                  )}
                </button>

                {/* Product Image */}
                <div className="relative bg-[#E5E5E5] overflow-hidden aspect-square">
                  <img
                    src={
                      product.images?.[0] ||
                      "https://via.placeholder.com/300x300?text=No+Image"
                    }
                    alt={productName}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/300x300?text=No+Image";
                    }}
                  />
                </div>

                {/* Product Info */}
                <div className="p-2">
                  {renderStars(product.ratings || 0)}

                  <h3 className="text-xs sm:text-sm text-gray-700 text-center mb-2 line-clamp-2 ">
                    {productName}
                  </h3>

                  <div className="text-center">
                    <div className="flex items-center justify-center gap-2">
                      {product.previous_price && (
                        <div className="text-xs sm:text-sm text-red-400 line-through">
                          {formatingPrice(
                            convertPrice(product.previous_price),
                            currency
                          )}
                        </div>
                      )}

                      <div className="text-base sm:text-lg font-bold text-gray-900">
                        {formatingPrice(convertPrice(product.price), currency)}
                      </div>
                    </div>
                  </div>

                  {/* Add to Cart */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddToCart(productId);
                    }}
                    disabled={isCartLoading}
                    className="mt-3 w-full bg-white border-2 border-gray-900 text-gray-900 py-1 md:py-2 text-sm font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
                  >
                    {isCartLoading ? (
                      <div className="flex justify-center items-center gap-2">
                        <Loader2 className="w-4 h-4 animate-spin" />
                        {t("adding") || "ADDING"}...
                      </div>
                    ) : (
                      t("add_to_cart") || "ADD TO CART"
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DesireChooseSection;